/**
 * A pool row's numbers: the weight (Manual % only) and "SMS a day" — the
 * cap of THIS lane, counted across the country (Phase 40).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { HintDot } from '@/components/ui';
import { cn } from '@/lib/utils';

import type { DraftPoolRow } from '../../../../drop-generator.types';
import type { GatewayOp } from '../../state/gateway-draft';
import { CAPACITY_HINT } from '../cards/strategy-copy';

const INPUT = 'h-7 rounded-md border border-border/60 bg-background px-2 text-xs tabular-nums outline-none focus:border-primary';
const FIELD = 'flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground';

const toInt = (value: string): number | null => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : null;
};

interface Props {
  row: DraftPoolRow;
  showWeight: boolean;
  onOp: (op: GatewayOp) => void;
}

export const PoolRowInputs: FC<Props> = ({ row, showWeight, onOp }) => {
  const patch = (p: { weight?: number | null; capacity?: number | null }) => onOp({ kind: 'poolPatch', id: row.id, patch: p });
  return (
    <>
      {showWeight ? (
        <label className={FIELD}>
          Weight
          <input type="number" min={0} max={100} value={row.weight ?? ''} placeholder="—" onChange={(e) => patch({ weight: e.target.value === '' ? null : Number(e.target.value) })} className={cn(INPUT, 'w-16')} />%
        </label>
      ) : null}
      <label className={FIELD}>
        SMS a day <HintDot label={CAPACITY_HINT} />
        <input type="number" min={1} value={row.capacity ?? ''} placeholder="no cap" onChange={(e) => patch({ capacity: toInt(e.target.value) })} className={cn(INPUT, 'w-24')} />
      </label>
    </>
  );
};
